import availablePaymentMethods from '@/models/paymentMethods';

export default {
    data() {
        return {
            isProceeding: false,
            //Errors
            formErrors: [],
            //payment
            paymentMethod: {},
            newsletterAccepted: false
        };
    },
    computed: {
        isDelayPayment() {
            if (this.checkout) {
                return this.checkout.checkoutMode === 'DelayPayment';
            }
            return false;
        },
        isArrivalDateSelectionPossible() {
            if (this.checkout) {
                return this.checkout.arrivalDateSelectionRequired;
            }
            return false;
        },
        isMultivoucher() {
            return this.$store.state.globalMeta.multivoucherShop;
        }
    },
    methods: {
        constructGtmItem() {
            return {
                item_id: this.checkout.trackingData.itemId,
                item_name: this.checkout.trackingData.itemName,
                item_brand: this.checkout.trackingData.itemBrand,
                item_category: this.checkout.trackingData.itemCategory,
                item_variant: this.checkout.trackingData.itemVariant,
                coupon: this.discountCoupon ? this.discountCoupon.code : null,
                price: (this.priceData.singleProductPrice || 0) / 100,
                currency: 'EUR',
                quantity: this.quantity
            };
        },
        constructOrderPayload() {
            let paymentMethodName = this.paymentMethod.name;

            // Map SOFORT and Paydirekt to Stripe
            if (
                paymentMethodName === 'SofortUeberweisung' ||
                paymentMethodName === 'Paydirekt' ||
                paymentMethodName === 'ApplePay' ||
                paymentMethodName === 'GooglePay'
            ) {
                paymentMethodName = 'Stripe';
            }

            return {
                paymentMethod: this.isDelayPayment ? availablePaymentMethods.prepayment.value : paymentMethodName,

                email: this.email,
                phone: this.phone,
                billingAddress: this.billingAddress,

                newsletterAccepted: this.newsletterAccepted,

                remainingAmountToPay: this.priceData.amountToPay,
                totalPrice: Math.max(this.priceData.orderTotal, 0),

                affiliateCampaign: this.$cookies.st || this.$cookies.ac,
                employeeId: this.$cookies.emp_id,
                contactId: this.$cookies.gr_s,

                ...(this.order
                    ? {
                          //CheckoutForOrder part
                          singleProductPrice: this.order.singleProductPrice,
                          orderId: this.orderId,
                          orderHash: this.orderHash
                      }
                    : {
                          //Checkout part
                          singleProductPrice: this.priceData.singleProductPrice,
                          productVariantId: this.finalProductVariantId,
                          valueVoucherProductId: this.valueVoucherProductId,
                          arrivalDate: this.arrivalDate,
                          cancellationOptin:
                              this.arrivalDateSelectionMode === 'nodate' ? false : this.cancellationOptin,
                          ...(this.differentShippingAddress && { shippingAddress: this.shippingAddress }),
                          shipment: this.shippingMethod || null, //fires error for multivoucher empty string shipment
                          selectedVoucherImage: this.selectedVoucherImage,
                          quantity: this.quantity,
                          biddingAmount: this.checkout.auctionOffer ? this.bidAmount : null,
                          ...(Object.keys(this.discountCoupon).length && { discountCoupon: this.discountCoupon }),
                          ...(this.valueVouchers.length && { valueVouchers: this.valueVouchers }),
                          //checkout traveller mode part https://gitlab.icslabs.de/animod/animod-libraries/issues/70
                          ...(this.persons.length && {
                              persons: this.persons.map((person, index, persons) => {
                                  let currentPerson = person;
                                  if (this.isTravellingAlone) {
                                      currentPerson = persons[0];
                                  }
                                  return {
                                      firstname: currentPerson.firstname || '-',
                                      lastname: currentPerson.lastname || '-',
                                      birthdate: currentPerson.birthdate || '-',
                                      nationality: currentPerson.nationality || ''
                                  };
                              })
                          }),
                          ...(this.infants.length && {
                              infants: this.infants.map(infant => ({
                                  firstname: '-',
                                  lastname: '-',
                                  birthdate: '01.01.' + (new Date().getFullYear() - +infant.age),
                                  nationality: person.nationality || ''
                              }))
                          }),
                          //multivoucher surcharge part
                          ...(this.checkout.price.surcharge && { surcharge: this.checkout.price.surcharge }),
                          //delay payment part
                          ...((this.isDelayPayment || this.isMultivoucher) && this.delayPayment),
                          //direct booking part
                          additionalInformation: this.additionalInformation,
                          loyaltyProgram: this.checkout.loyaltyProgram,
                          loyaltyCardNumber: this.loyaltyCardNumber,
                          membershipCardNumber: this.membershipCardNumber,
                          additionalPlatformConsentGiven: this.additionalPlatformConsentGiven,
                          accessCode: this.accessCode
                      })
            };
        },
        async initAmazonConfirmationFlow() {
            try {
                return await this.$refs.paymentMethodComponent.initAmazonConfirmationFlow();
            } catch (confirmationFlowError) {
                this.formErrors = [confirmationFlowError];
            }
        },
        async placeOrder() {
            let amazonConfirmationFlow;

            if (this.priceData.amountToPay) {
                if (this.paymentMethod.name === availablePaymentMethods.amazonPay.value) {
                    amazonConfirmationFlow = await this.initAmazonConfirmationFlow();
                    if (!amazonConfirmationFlow) return;
                }
            }

            const order = this.constructOrderPayload();

            // Update access code in case of douglas preview code?
            if (order.accessCode) {
                this.$store.dispatch('setToken', order.accessCode);
            }

            // Update multivoucher code with the value voucher from the payload if:
            // - this is a multivoucher shop
            // - and we do have at least one valuevoucher in the payload
            if (this.$store.state.globalMeta.multivoucherShop && order.valueVouchers) {
                this.$store.dispatch('setMultiVoucherCode', order.valueVouchers[0].code);
            }

            this.isProceeding = true;

            try {
                const orderResult = await this.$store.dispatch('processOrder', order);

                if (orderResult.redirectUrl) {
                    //TODO: some page overlay before redirect occurs?
                    //Vue-Router doesn't allow to navigate to absolute paths outside ot it's scope
                    const inIframe = window.self !== window.top;
                    //const requiresNewTab = [availablePaymentMethods.paydirekt.value, availablePaymentMethods.stripe.value, availablePaymentMethods.payPalPlus.value, availablePaymentMethods.payPal.value].includes(orderResult.paymentMethod)

                    if (inIframe) {
                        window.open(
                            (location.href = orderResult.redirectUrl),
                            '_parent' // <- This is what makes it open in a new window.
                        );
                    } else location.href = orderResult.redirectUrl;
                } else if (orderResult.errors.length) {
                    //If we're processing amazon payment, then need to reject it
                    amazonConfirmationFlow && amazonConfirmationFlow.error();

                    this.formErrors = orderResult.errors.map(error => this.$t('Checkout.error.' + error.text));
                } else {
                    //If we're processing amazon payment, then need to resolve it
                    amazonConfirmationFlow && amazonConfirmationFlow.success();

                    const { orderId, orderHash } = orderResult;
                    this.$router.push({
                        name: 'success',
                        params: {
                            orderId,
                            orderHash
                        }
                    });
                }
            } catch (error) {
                amazonConfirmationFlow && amazonConfirmationFlow.error();

                if (error.response && error.response.status === 400 && error.response.data) {
                    this.formErrors = error.response.data.map(error => {
                        const field = this.$t('Checkout.error.' + error.field);
                        const text = this.$t('Checkout.error.' + error.text);
                        if (field !== text) {
                            return `${field} - ${text}`;
                        } else {
                            return field;
                        }
                    });
                }
            } finally {
                this.isProceeding = false;
            }
        }
    },
    beforeDestroy() {
        this.$store.commit('setMobileHeaderTitle', null);
    }
};
